export * from './components';
export * from '@omegagrid/tree';
export * from '@omegagrid/toolbar';
export * from '@reporting/rp-app-host';
// export * from './types';

import { ComponentId } from '@omegagrid/core';
import rp, { AppComponent, Application, Container, parseComponentId } from '@reporting/rp-app-host';
import { componentFactories } from './factories';
import { Project } from '@reporting/rp-types/ext';

export class ExtensionApplication extends Application {

	activeProject: Project;

	async register(container: Container) {
		super.register(container);
		container.services.register('extensions');
	}

	async init(container: Container) {
		super.init(container);
		container.services.register('extensions');
	}

	createComponent(id: ComponentId): AppComponent|Promise<AppComponent> {
		const parsedId = parseComponentId(id);
		const factory = componentFactories.get(parsedId.id as string || parsedId.type);
		if (!factory) return null;
		return factory(this, parsedId) as AppComponent|Promise<AppComponent>;
	}

}
